import React, { useEffect, useState} from "react";
import { getDomainConfig } from "../../config/config";

const StandardFieldset = (props) => {

const config = getDomainConfig();

/* LOADING THE BRANDED SCSS */
const [styles, setStyles] = useState(false);

useEffect(() => {

const getStyles = async (theFileName, theFileEnd) => {
  if (config.brand) {
    let moduleStyles = false;
    try {
      moduleStyles = await import(
        "./" + theFileName + config.brand + theFileEnd
      );
      setStyles(moduleStyles);
    } catch (e) {
      console.error(
        `Styles for ${theFileName} could not be loaded, ${e.message}`
      );
    }
  }
};

  // Specify file name and end of file name here.
  getStyles("StandardFieldset", ".module.scss");
}, [config.brand]);

/* END LOADING THE BRANDED SCSS */


  const propsId = props.id; // The id that may have come through from props
  let defaultClass = styles.group; // The generic class (in css modules format)
  let classes = defaultClass; // The classes list to show

  if (props.className) { // If any extra classes come through via props, turn them into css modules format too
    classes = classes + ' ' + props.className.split(' ').map(thisStyle => {
      return styles[thisStyle];
    }).join(' ');
  }

  return (
    <fieldset className={classes} id={propsId}>
      {props.children}
    </fieldset>
  );
};

export default StandardFieldset;
